import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import appSlice from './appSlice';
import { clientApi } from './services/client';
import { userApi } from './services/user';
import userSlice from './userSlice';
import noticesSlice from './noticesSlice';
import { rtkQueryErrorLogger } from '../utils/middleware/errorHandler';
import { authApi } from './services/auth';
import { loggerApi } from './services/logger';
import { ldapApi } from './services/ldap';
import { ethereumApi } from './services/ethereum';
import { mailApi } from './services/mail';
import { ownerApi } from './services/owner';
import { smsApi } from './services/sms';
import { phoneApi } from './services/phone';
import { setupListeners } from '@reduxjs/toolkit/query';
import { emptySplitApi } from './services/api';

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

const store = configureStore({
  reducer: {
    user: userSlice,
    app: appSlice,
    notices: noticesSlice,
    [emptySplitApi.reducerPath]: emptySplitApi.reducer,
    [clientApi.reducerPath]: clientApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [loggerApi.reducerPath]: loggerApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [ldapApi.reducerPath]: ldapApi.reducer,
    [ethereumApi.reducerPath]: ethereumApi.reducer,
    [mailApi.reducerPath]: mailApi.reducer,
    [ownerApi.reducerPath]: ownerApi.reducer,
    [smsApi.reducerPath]: smsApi.reducer,
    [phoneApi.reducerPath]: phoneApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      emptySplitApi.middleware,
      clientApi.middleware,
      userApi.middleware,
      loggerApi.middleware,
      ldapApi.middleware,
      ethereumApi.middleware,
      mailApi.middleware,
      ownerApi.middleware,
      smsApi.middleware,
      phoneApi.middleware,
      authApi.middleware,
      rtkQueryErrorLogger,
    ),
});

setupListeners(store.dispatch);

export const useAppDispatch = () => useDispatch<AppDispatch>();
export default store;
